import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import Button from '@base/Button/Button';
import imageHelper from '@utils/imageHelper';
import React from 'react';
import styled from 'styled-components';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';

const Container = styled(Drawer)`
  display: none;
  &.MuiDrawer-root > .MuiPaper-root {
    background: linear-gradient(0deg, #eef6ff 0%, #f7faff 100%), #ffffff;
    box-shadow: 0px -8px 24px rgba(11, 11, 11, 0.12);
    border-radius: 16px 16px 0px 0px;
    overflow: hidden;
  }
  @media (max-width: 47.95em) {
    display: block;
  }
`;

const Wrapper = styled.div`
  text-align: center;
  background: url(${imageHelper.getImage('goal/learn-bg.png')}) no-repeat;
  background-size: 197px 130px;
  background-position: top 32px center;
`;

const Title = styled(H4)`
  @media (max-width: 47.95em) {
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    margin-bottom: 8px;
  }
`;

const SubTitle = styled(P1)`
  text-align: center;
  padding: 0 36px;
`;

const DownloadButton = styled(Button)`
  width: calc(100% - 32px);
  margin: 24px 16px;
`;

const Image = styled.img`
  object-fit: contain;
  margin: 32px auto 36px;
`;

const CloseIcon = styled.img`
  position: absolute;
  right: 16px;
  top: 16px;
`;

export default function Version1({ installLink, onClose, open }) {
  const handleClick = () => {
    window.open(installLink, '_blank');
  };
  return (
    <Container anchor="bottom" open={open} onClose={onClose}>
      <Wrapper>
        <CloseIcon
          src={imageHelper.getImage('k12/close-circle-filled.png')}
          alt="close"
          width="24"
          height="24"
          onClick={onClose}
          aria-hidden="true"
        />
        <Image
          src={imageHelper.getImage('goal/learn.png')}
          alt="Download Unacademy app"
          width="140"
          height="120"
        />
        <Title>Get the app to continue</Title>
        <SubTitle>
          Watch live classes, take tests, combats and a lot more on the app
        </SubTitle>
        <DownloadButton label="Get the Unacademy app" onClick={handleClick} />
      </Wrapper>
    </Container>
  );
}

Version1.propTypes = {
  installLink: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

Version1.defaultProps = {
  installLink: 'https://unacademy.app.link/LtwR6CRyLcb'
};
